import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import {
  formatDate,
  getSQLDateFormat,
} from '../../utils/date'

const useStyles = makeStyles((theme) => ({
  month: {
    padding: '10px'
  },
}))

const HeraldMonth = ({
  month,
  year,
  dates,
  selectedDate,
  onOpenDate,
}) => {
  const classes = useStyles()
  const title = `${month} ${year}`
  return (
    <div className={ classes.month }>
      <Typography variant="h5">{ title }</Typography>
      <List
        dense
        component="nav"
      >
        {dates.map((date) => (
          <ListItem
            button
            key={date}
            selected={ getSQLDateFormat(date) == selectedDate }
            onClick={ () => onOpenDate(getSQLDateFormat(date)) }
          >
            <ListItemText primary={formatDate(date)} />
          </ListItem>
        ))}
      </List>
    </div>
  )
}


const HeraldMenu = ({
  isAdminMode,
  selectedDate,
  onOpenDate,
}) => {
  const startDate = new Date('2023-12-01')
  const endDate = new Date('2024-11-30')

  const months = []

  // Loop over each day between start date and end date
  for (let date = new Date(endDate); date >= startDate; date.setDate(date.getDate() - 1)) {
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    // Check if the month already exists in the months array
    const existingMonth = months.find((m) => (m.month == month && m.year == year));
    if (existingMonth) {
      existingMonth.dates.push(new Date(date));
    } else {
      months.push({
        month,
        year,
        dates: [new Date(date)],
      })
    }
  }

  return (
    <>
      {months.map((month, i) => (
        <HeraldMonth
          key={i}
          month={month.month}
          year={month.year}
          dates={month.dates}
          selectedDate={ selectedDate }
          onOpenDate={ onOpenDate }
        />
      ))}
    </>
  );
};

export default HeraldMenu